import React from 'react';
import { Checkbox, CheckboxProps } from 'antd';
// import { CheckboxChangeEvent } from 'antd/es/checkbox';
import styled from 'styled-components';
// export interface CheckOptions extends CheckboxProps {
//   onChangeFunction?: (e: CheckboxChangeEvent) => void;
// }
// 使用 styled-components 封装 Checkbox 样式
const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    width: 16px; /* 缩小一半 */
    height: 16px; /* 缩小一半 */
    border-radius: 50%;
    background-color: white; /* 未选中时背景为白色 */
    border: 1px solid #d9d9d9; /* 未选中时边框为灰色 */
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }

  .ant-checkbox-inner::after {
    border: 0px solid white;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #7ed321; /* 选中时背景为绿色 */
    border: 1px solid #7ed321; /* 选中时边框改为绿色 */
  }

  /* 修改选中时的白色对号 */
  .ant-checkbox-checked .ant-checkbox-inner::after {
    content: '✔'; /* 白色对号 */
    color: 'white' !important;
    font-size: 10px; /* 缩小对号的大小 */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* 居中对号 */
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: #f0f0f0 !important; /* 禁用时背景为浅灰色 */
    border: 2px solid #d9d9d9 !important; /* 禁用时边框为灰色 */
  }

  .ant-checkbox-disabled .ant-checkbox-inner::after {
    background-color: white !important;
  }
`;

// 封装后的 Checkbox 组件
const CustomCheckbox: React.FC<CheckboxProps> = (props) => {
  return <StyledCheckbox {...props} />;
};

export default CustomCheckbox;
